import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import './ExportsView.css';
import LeftNavigationBar from "../LeftNavigationBar/LeftNavigationBar";
import { getExports } from "../../services/exports.service";
import { DownloadIcon } from "../../assets/images/svgs/Icons";
import ImageIconSvg from '../../assets/images/svgs/ImageIcon.svg?react'
import { formatFullDate } from "../../common/utils/helperFunctions";

const ExportsView = () => {

    const dispatch = useDispatch();
    const exports = useSelector(state => state.exportDetails.exports);
    const loadingExports = useSelector(state => state.exportDetails.loadingExports);
    const collectionsData = useSelector((state) => state.collectionDetails.collections);

    const getCollectionName = (collection) => {
        const selectedCollection = collectionsData.find((item) => collection.collectionID === item.collectionID);
        return selectedCollection && selectedCollection.name;
    };

    useEffect(() => {
        dispatch(getExports());
    }, [dispatch]);

    const showExportsList = () => {
        return (
            <div className="exports-list-view">
                {exports.map((item, index) => (
                    <div className="export-list-item bottomBorder" key={index}>
                        <div className="item-icon"><ImageIconSvg /></div>
                        <div className="item-details">
                            <div className="item-title">{getCollectionName(item)}</div>
                            <div className="item-sub-title">{item.item} | {formatFullDate(item.createdAt)} | {item.status}</div>
                        </div>
                        <div className="item-content">
                            <div className="item-location">Personal Storage</div>
                            <div className="item-tags-group">
                                {
                                    item?.assets?.map((item, index) =>
                                        (<div className="item-tag" key={index}>{item}</div>)
                                    )
                                }
                                {
                                    item?.orderAsset?.types?.map((item, index) =>
                                        (<div className="item-tag" key={index}>{item}</div>)
                                    )
                                }
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    };

    return (
        <div className="exportsView">
            <LeftNavigationBar />
            <div className="exports-section">
                <div className="export-header bottomBorder">
                    <span className="exports-icon"> <DownloadIcon /> </span>
                    <span className="exports-title">Downloads</span>
                </div>
                {
                    loadingExports ? <h5 style={{ marginTop: '10px' }}>Loading exports...</h5> :
                        exports.length > 0 ?
                            showExportsList()
                            : <h5 style={{ marginTop: '10px' }}>No downloads available</h5>
                }
            </div>
        </ div>
    )
};

export default ExportsView;